import { SwDerivedApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import {
  userStore,
  userTodosStore,
} from "@sourcewhale/shared/src/svelte/api-stores/user-store";
import { queryTodos } from "@sourcewhale/api";
import { derived } from "svelte/store";

const manualToDoCounterStore = SwDerivedApiStore({
  get: queryTodos,
  argsStore: userStore,
  argsTransform: (args) => {
    if (!args || !args.hasCrm) return null;
    const body = {
      kind: "manualToDo",
      status: "active",
      search: { value: "" },
      start: 0,
      length: 0,
      draw: 0,
      userId: args.userId,
    };
    return [body];
  },
  onMessage: ({ message }) => {
    if (message.kind === "update-manual-to-dos") {
      setTimeout(() => manualToDoCounterStore.get(), 3000);
    }
  },
  cacheKey: "userManualToDos",
  debounceDelayMs: 100,
  resetBeforeFetch: false,
});

export const todosCountStore = derived(
  [userTodosStore, manualToDoCounterStore],
  ([$userTodosStore, $manualToDoCounterStore]) => {
    const { toDos = 0 } = $userTodosStore;
    const manualToDos = $manualToDoCounterStore.recordsTotal || 0;
    const totalToDos = toDos + manualToDos;
    return totalToDos > 99 ? "99+" : `${totalToDos}`;
  },
);
